import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import getToken from "store/token";

const getAIBillingOrigin = () => {
  const host = window.location.hostname;

  // Production
  if (host === "billing-web.services.orcicare.com") {
    return "https://aibilling.services.orcicare.com";
  }

  // Local, test, staging, etc.
  return "https://aibilling.services.orcicare.com";
};

const AIBILLING_ORIGIN = getAIBillingOrigin();

const IFRAME_URL = `${AIBILLING_ORIGIN}/dashboard`;

const AIDashboard = () => {
  const iframeRef = useRef(null);
  const isIframeReadyRef = useRef(false);

  const token = getToken();

  const authData = useSelector((state) => state.auth.authData);

  const practiceId = authData?.selected_practice;
  const practiceName = authData?.selected_practice_name;

  const sendTokenToIframe = () => {
    if (!iframeRef.current?.contentWindow) return;
    if (!token) return;
    if (!isIframeReadyRef.current) return;

    iframeRef.current.contentWindow.postMessage(
      {
        type: "AIBilling:setAuthToken",
        token,
        practice_id: String(practiceId),
        practice_name: practiceName,
      },
      AIBILLING_ORIGIN,
    );
  };

  useEffect(() => {
    const handleLoad = () => {
      sendTokenToIframe();
    };

    const iframe = iframeRef.current;

    iframe?.addEventListener("load", handleLoad);

    return () => {
      iframe?.removeEventListener("load", handleLoad);
    };
  }, []);

  useEffect(() => {
    if (isIframeReadyRef.current) {
      sendTokenToIframe();
    }
  }, [token, practiceId, practiceName]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== AIBILLING_ORIGIN) return;

      if (
        event.data?.type === "AIBilling:ready" ||
        event.data?.type === "AIBilling:requestAuthToken"
      ) {
        isIframeReadyRef.current = true;
        sendTokenToIframe();
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const handleLogout = () => {
      const iframe = iframeRef.current;

      if (!iframe?.contentWindow) return;

      isIframeReadyRef.current = false;

      iframe.contentWindow.postMessage(
        { type: "AIBilling:logout" },
        AIBILLING_ORIGIN,
      );
    };

    window.addEventListener("aibilling-logout", handleLogout);

    return () => {
      window.removeEventListener("aibilling-logout", handleLogout);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={IFRAME_URL}
      title="AI Billing Dashboard"
      width="100%"
      height="100%"
      style={{
        border: "none",
        minHeight: "100vh",
      }}
    />
  );
};

export default AIDashboard;
